import { useMarketplaceTrackingQuery } from '@anytag/graphql';
import { RenderDataWithFallback } from '@anytag/shared-atoms';
import { THEME } from '@anytag/shared-constants';
import { TrackingUrl } from '@anytag/shared-organisms';
import { useMarketplaceDetailsContext } from '../marketplace-details-context';

export const MarketplaceTrackingUrl = () => {
  const { marketplaceId } = useMarketplaceDetailsContext();
  const { data, loading } = useMarketplaceTrackingQuery({ fetchPolicy: 'cache-first', variables: { marketplaceId } });

  return (
    <RenderDataWithFallback loading={loading}>
      <TrackingUrl css={{ boxShadow: THEME.shadows.boxShadow }} postbackUrl={data?.marketplaceTracking?.postbackUrl} />
    </RenderDataWithFallback>
  );
};
